"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function payloadId() {
  var date = Date.now() * Math.pow(10, 3);
  var extra = Math.floor(Math.random() * Math.pow(10, 3));
  return date + extra;
}

exports.payloadId = payloadId;
exports.default = payloadId;